module.exports = __webpack_public_path__ + "img/apply.721559b4.png";